<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <md-list-item to="/">
            <p>ingenieria y soluciones civiles S.A.S.</p>
          </md-list-item>
          <md-list-item to="/servicios">
            <p>Servicios</p>
          </md-list-item>
          <md-list-item to="/conocenos">
            <p>Conócenos</p>
          </md-list-item>
          <md-list-item to="/contactanos">
            <p>Contáctanos</p>
          </md-list-item>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, made by
        <a href="http://whatha-design.web.app/" target="_blank"
          >WHATHA DESIGN</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
